import { render, staticRenderFns } from "./Relacionados.vue?vue&type=template&id=3f676cde&"
import script from "./Relacionados.vue?vue&type=script&lang=js&"
export * from "./Relacionados.vue?vue&type=script&lang=js&"
import style0 from "./Relacionados.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports